<template>
  <div>
    <CreateMapEditor 
        :canDraw="canDraw" 
        :widthStyle="false" 
        :canEditPolygon="canEditPolygon"
        :canEditAndInteract="true"
        :detailsAreaPanelActive="false"
        :reviewAreaPanelActive="false"
        :queryPcode="queryPcode"
    />
  </div>
</template>

<script>

import CreateMapEditor from '../common/Create/CreateMapEditor';

export default {
    components : {
        CreateMapEditor : CreateMapEditor
    },
    data(){
        return {
            canDraw : 'polygon',
            canEditPolygon : false,
            queryPcode : ''
        }
    },
    computed : {
        polygonDrawn(){
            return this.$store.getters.polyGonCreated
        }
    },
    watch : {
        polygonDrawn : function(newVal, oldVal){
         
            if(newVal.length > 0){
                this.canDraw = null;
                this.canEditPolygon = true;
            } else {
                this.canDraw = 'polygon';
                this.canEditPolygon = false;
            }
        }
    },
    mounted(){
        if(this.polygonDrawn.length > 0){
            this.canDraw = null
            this.canEditPolygon = true;
        } else {
            this.canDraw = 'polygon';
            this.canEditPolygon = false;
        }
        
        // set queryparam if present
        if(this.$route.query.pcode){
            this.queryPcode = this.$route.query.pcode;
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/CreateSelectAnArea.vue